import { colors } from 'theme/colors';

export const STATUS_OPTIONS = [
  { code: 140, label: 'Course completed', passFail: true },
  { code: 141, label: 'Training completed', passFail: true },
  { code: 150, label: 'Course passed', passFail: true },
  { code: 151, label: 'Training passed', passFail: true },
] as const;

export const COMPLIANCE_STATUS_CONFIG: Record<string, { label: string; background: string; color: string }> = {
  compliant: {
    label: 'Compliant',
    background: colors.toast.success.background,
    color: colors.toast.success.text,
  },
  non_compliant: {
    label: 'Non-Compliant',
    background: colors.toast.error.background,
    color: colors.toast.error.text,
  },
  not_required: {
    label: 'Not Required',
    background: colors.grey[100],
    color: colors.grey[600],
  },
  outstanding: {
    label: 'Outstanding',
    background: colors.toast.warning.background,
    color: colors.toast.warning.text,
  },
  expiring_soon: {
    label: 'Expiring Soon',
    background: colors.toast.warning.background,
    color: colors.toast.warning.text,
  },
  archived: {
    label: 'Archived',
    background: colors.grey[100],
    color: colors.grey[600],
  },
};
